module.exports = __webpack_public_path__ + "img/tooltip-icon.3afda988.svg";